<template>
  <Tag v-if="showTag" :severity="getSeverity()" class="text-xs! h-5!">{{ params.value }}</Tag>
  <p v-else>{{ params.value }}</p>
</template>

<script setup lang="ts">
import { CustomFieldDataType } from "@/enums/CustomFieldDataType";
import { CustomFieldScope } from "@/enums/CustomFieldScope";
import { CustomTagType } from "@/enums/CustomTagType";

const props = defineProps(["params"]);

const getShowTag = (): boolean => {
  switch (props.params.type) {
    case CustomTagType.SOURCE_TYPE:
      return props.params.value && props.params.value !== "TOTAL";
    default:
      return true;
  }
};

const showTag = ref(getShowTag());

const customFieldScope = (): string => {
  switch (props.params.value.toUpperCase()) {
    case CustomFieldScope[CustomFieldScope.PROJECT]:
      return "primary";
    case CustomFieldScope[CustomFieldScope.DRAW]:
    default:
      return "secondary";
  }
};

const customFieldDataType = (): string => {
  switch (props.params.value.toUpperCase()) {
    case CustomFieldDataType[CustomFieldDataType.TEXT]:
      return "primary";
    case CustomFieldDataType[CustomFieldDataType.BOOLEAN]:
      return "secondary";
    case CustomFieldDataType[CustomFieldDataType.NUMERIC]:
      return "help";
    case CustomFieldDataType[CustomFieldDataType.LIST]:
      return "warning";
    case CustomFieldDataType[CustomFieldDataType.DATE]:
      return "info";
    default:
      return "primary";
  }
};

const sourceType = (): string => {
  switch (props.params.value.toUpperCase()) {
    case "PRIMARY BORROWER":
    case "BORROWER":
      return "primary";
    case "PRIMARY LENDER":
    case "LENDER":
    default:
      return "secondary";
  }
};

const paymentType = (): string => {
  switch (props.params.value) {
    case "Paid":
      return "success";
    case "Void":
      return "danger";
    default:
      return "info";
  }
};

const customCostType = (): string => {
  switch (props.params.value) {
    case "SOFT":
      return "success";
    case "HARD":
      return "danger";
    default:
      return "info";
  }
};

const userType = (): string => {
  switch (props.params.value.toUpperCase()) {
    case "ADMIN":
      return "primary";
    default:
      return "info";
  }
};

const projectStatusCategory = (): string => {
  switch (props.params.value.toUpperCase()) {
    case "PENDING":
      return "warning";
    case "ACTIVE":
      return "success";
    default:
      return "info";
  }
};

const getSeverity = (): string => {
  switch (props.params.type) {
    case CustomTagType.CUSTOM_FIELD_SCOPE:
      return customFieldScope();
    case CustomTagType.CUSTOM_FIELD_DATA_TYPE:
      return customFieldDataType();
    case CustomTagType.SOURCE_TYPE:
      return sourceType();
    case CustomTagType.PAYMENT_STATUS:
      return paymentType();
    case CustomTagType.CUSTOM_COST_TYPE:
      return customCostType();
    case CustomTagType.USER_TYPE:
      return userType();
    case CustomTagType.PROJECT_STATUS_CATEGORY:
      return projectStatusCategory();
    default:
      return "primary";
  }
};
</script>
